import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useContext } from 'react';
import { useAppContext } from '../../Context/AppContext';

const WhiteCard = (props) => {
    const { data } = props;
    const { BASE_PATH } = useContext(useAppContext);

    // Map new backend fields to old component expectations
    const title = data.posttitle || data.title || "No Title";
const image = data.imagepath || data.image || "";
const articleurl = data.articleurl || data.post_url || data.posturltitle || "#"; // ✅ FIXED
const categorytitle = data.categoryname || data.categorytitle || "";
const categoryurl = data.categoryurl || "";

    return (
        <Col lg={3} md={6} sm={6} xs={6} className='p-2'>
            <Card>
                <Card.Img 
                    variant="top" 
                    src={image} 
                    alt={title} 
                    loading="lazy" 
                    onError={(e) => { e.target.style.display = 'none'; }} // Hide broken image gracefully
                />
                <Card.Body>
                    {categorytitle && (
                        <Card.Text className='card-category'>{categorytitle}</Card.Text>
                    )}
      <Card.Link href={`${BASE_PATH}${categoryurl || ""}/${articleurl || ""}`}>         
               <Card.Title className='word-line-limit'>{title}</Card.Title>
                    </Card.Link>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default WhiteCard;